<template>
  <div class="flex flex-col w-full leading-tight min-h-screen overflow-hidden bg-surface">
    <div class="w-full bg-header shadow md:mb-4">
      <PageHeaderCheckout :has-go-back-button="!isMobile" />
    </div>
    <Usps color="accent" class="mb-4 md:hidden" />
    <div class="page-container--small">
      <slot v-if="loaded" />
    </div>
    <Usps color="primary" class="mb-4 md:hidden" />
    <CustomerSupportCard />
    <div v-if="!isB2C" class="w-full bg-gray-900 border-b-primary border-b-4 mt-auto">
      <div class="py-10 lg:flex items-center justify-center lg:page-container">
        <div>
          <FooterCompany simple />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CustomerSupportCard from "@/components/checkout/CustomerSupportCard.vue";
import PageHeaderCheckout from "@/components/page/PageHeaderCheckout.vue";
import brandconfig from "@/brandconfig";
import { useI18n } from "vue-i18n";
import { setTitle } from "@m-media/vue3-meta-tags";
import { onMounted, ref } from "vue";
import { useUserStore } from "@/store/user";
import FooterCompany from "@/components/page/FooterCompany.vue";
import { isB2C } from "@/brandconfig";
import { useRouter } from "vue-router";
import Usps from "@/pages/event/Usps.vue";
import { useBreakpoints } from "@xs2event/js-lib/util";

const { t } = useI18n();
setTitle(`${t("Checkout")} | ${brandconfig.BRAND_SHORT_TITLE}`);

const userStore = useUserStore();
const router = useRouter();

const loaded = ref(false);

// Guard to redirect to homepage if not b2c
if (!isB2C) {
  router.push({ path: "/" });
}
const breakpoints = useBreakpoints();

const isMobile = breakpoints.smaller("lg");

onMounted(() => {
  userStore.fetchDistributor().finally(() => {
    loaded.value = true;
  });
});
</script>
